function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.85
}, /*#__PURE__*/React.createElement("path", {
  d: "M9 0.53125C4.18359 0.53125 0.28125 4.43359 0.28125 9.25C0.28125 14.0664 4.18359 17.9688 9 17.9688C13.8164 17.9688 17.7188 14.0664 17.7188 9.25C17.7188 4.43359 13.8164 0.53125 9 0.53125ZM16.5938 9.25C16.5938 13.4336 13.1836 16.8438 9 16.8438C4.81641 16.8438 1.40625 13.4688 1.40625 9.25C1.40625 5.10156 4.78125 1.65625 9 1.65625C13.1484 1.65625 16.5938 5.06641 16.5938 9.25ZM11.3555 12.3789C11.5312 12.5195 11.8125 12.4492 11.918 12.2734L12.2344 11.8867C12.375 11.6758 12.3047 11.4297 12.1289 11.2891L9.66797 9.49609V4.32812C9.66797 4.11719 9.45703 3.90625 9.24609 3.90625H8.75391C8.50781 3.90625 8.33203 4.11719 8.33203 4.32812V9.95312C8.33203 10.0938 8.36719 10.1992 8.47266 10.3047L11.3555 12.3789Z",
  fill: "white"
}));

function SvgTime(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default __webpack_public_path__ + "static/media/time.e7cb2c04.svg";
export { ForwardRef as ReactComponent };